module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n	.gl-object-info-form {\n		padding: 10px;\n	}\n\n	.gl-object-info-form .info {\n		margin-bottom: 12px;\n	}\n\n	.gl-object-info-form .info .title {\n		margin-bottom: 12px;\n		font-size: 18px;\n		font-weight: bold;\n	}\n\n	.gl-object-info-form .tabs-header {\n		margin-bottom: 12px;\n	}\n\n	.gl-object-info-form .tabs-header .active {\n		background: #888888;\n	}\n</style>\n\n<script src=\"js/utils/cameras.port/camera-photos-observer.js\"></script>\n<script src=\"js/utils/cameras.port/extended-date.js\"></script>\n<script src=\"js/utils/cameras.port/image-player.js\"></script>\n\n")
    ;  var data = widget.data; 
    ; __append("\n<div class=\"gl-object-info-form\">\n	<div class=\"table wh100\">\n		<div>\n			<div>\n				<div class=\"table\" style=\"table-layout: fixed\">\n					<div>\n						<div style=\"width: 300px\">\n							<div class=\"info\">\n								<div class=\"title\">")
    ; __append(escapeFn( data.name ))
    ; __append("</div>\n								<div>")
    ; __append(escapeFn( data.typename ))
    ; __append("</div>\n								<div>Ведомство: ")
    ; __append(escapeFn( Department.title(data.department) ))
    ; __append("</div>\n\n								<div>Адрес: ")
    ; __append(escapeFn( data.addresstext ))
    ; __append("</div>\n								<div>")
    ; __append(escapeFn( data.description ))
    ; __append("</div>\n							</div>\n						</div>\n						<div style=\"width: 800px\">\n							<div class=\"tabs-header\">\n								")
    ;  Util.each(widget.tabs, function (tab, key) { 
    ; __append("\n								<button class=\"button\" name=\"")
    ; __append(escapeFn( tab.header ))
    ; __append("\" on-click=\"onTabClick\"\n										data-tab=\"")
    ; __append(escapeFn( key ))
    ; __append("\">")
    ; __append(escapeFn( tab.name ))
    ; __append("</button>\n								")
    ;  }) 
    ; __append("\n							</div>\n\n							")
    ;  var key = "cameras"; 
    ; __append("\n							")
    ;  var tab = widget.tabs[key]; 
    ; __append("\n							")
    ;  if (tab) { 
    ; __append("\n							<div class=\"block tab\" name=\"")
    ; __append(escapeFn( tab.body ))
    ; __append("\" style=\"display: none\">\n								")
    ; __append( UI.Template.render("Glonass/ObjectInfoForm/Camera", { cameras: data.cameras }) )
    ; __append("\n							</div>\n							")
    ;  } 
    ; __append("\n\n							")
    ;  var key = "plans"; 
    ; __append("\n							")
    ;  var tab = widget.tabs[key]; 
    ; __append("\n							")
    ;  if (tab) { 
    ; __append("\n							<div class=\"block tab\" name=\"")
    ; __append(escapeFn( tab.body ))
    ; __append("\" style=\"display: none\">\n								<div name=\"")
    ; __append(escapeFn( key ))
    ; __append("-map\" style=\"height: 600px;\"></div>\n							</div>\n							")
    ;  } 
    ; __append("\n\n							")
    ;  var key = "documents"; 
    ; __append("\n							")
    ;  var tab = widget.tabs[key]; 
    ; __append("\n							")
    ;  if (tab) { 
    ; __append("\n							<div class=\"block tab\" name=\"")
    ; __append(escapeFn( tab.body ))
    ; __append("\" style=\"display: none\">\n								<div name=\"")
    ; __append(escapeFn( key ))
    ; __append("-map\" style=\"height: 600px;\"></div>\n							</div>\n							")
    ;  } 
    ; __append("\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n")
  }
  return __output.join("");

}